/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TDesktopGetNotificationsCountModel,
  IDesktopGetNotificationsCountRequest,
  IMappers,
  IDesktopGetNotificationsCountResponse,
  IDesktopGetNotificationsCountResponseError,
  TDesktopGetNotificationsCountResponse,
} from './types';

const defaultConfig: TDesktopGetNotificationsCountModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'notification-center',
  pathApi: '/v1/desktop/get-notifications-count/',
  hostType: 'api',
} as TDesktopGetNotificationsCountModel;

function createDesktopGetNotificationsCountModel(
  parameters: IDesktopGetNotificationsCountRequest,
): TDesktopGetNotificationsCountModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDesktopGetNotificationsCountOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IDesktopGetNotificationsCountRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchDesktopGetNotificationsCount<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IDesktopGetNotificationsCountOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TDesktopGetNotificationsCountResponse
> {
  const { response, statusCode } = await httpApi.fetch(createDesktopGetNotificationsCountModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDesktopGetNotificationsCountResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IDesktopGetNotificationsCountResponseError);
    }
  }

  return { response, statusCode } as TDesktopGetNotificationsCountResponse;
}

export { defaultConfig, createDesktopGetNotificationsCountModel, fetchDesktopGetNotificationsCount };
